module.exports = __webpack_public_path__ + "images/ic-spark_542a86a5a36140d284db3484cfcc5995.svg";